import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Helpers from '../Helpers';
import noimage from '../images/noimage.png';

const styles = {
    container: {
        width: '100%',
        backgroundColor: '#F8F8F8',
        padding: 16,
    },
    scrollArea: {
        width: '100%',
        height: 'calc(100vh - 180px)',
        overflowY: 'auto',
    },
    title: {
        borderBottom: '2px solid #D3873B',
        fontWeight: 'bold',
        fontSize: '1.25rem',
    },
    card: {
        backgroundColor: '#fff',
        borderRadius: 8,
        boxShadow: '0 2px 6px rgba(211, 135, 59, 0.25)',
        marginBottom: 10,
        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
        display: 'flex',
        flexDirection: 'row',
    },
    cardImg: {
        width: '25%',
        height: 100, // altura fixa ou adaptável
    },
    imgMedia: {
        width: '100%',
        height: '100%',
        objectFit: 'contain', // mantém a proporção sem cortar
        objectPosition: 'center', // centraliza
    },
    cardInfo: {
        width: '75%',
        padding: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
    },
    descProd: {
        fontWeight: 'bold',
        fontSize: '0.9rem',
    },
    vrProd: {
        fontWeight: 'bold',
        fontStyle: 'italic',
        fontSize: '1.35rem',
        textAlign: 'right',
    },
};

function Produtos({produtos, subgrupoRefs}){
    const registros = Object.entries(produtos);

    return(
        <Container style={styles.container}>
            <div style={styles.scrollArea}>
                {registros.map(([subgrupo, listaItens], index) => (
                    <div key={index} ref={(el)=>(subgrupoRefs.current[subgrupo] = el)} style={{ marginBottom: 50 }}>
                        <Row>
                            <Col md={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 25 }}>
                                <span style={styles.title}>{subgrupo}</span>
                            </Col>
                        </Row>

                        <Row>
                            {listaItens.map((item, chave) => {
                                const imgProduto = !item.cmImagem || item.cmImagem.includes('default') ? noimage : item.cmImagem;

                                return (
                                    <Col key={chave} md={6} sm={1}>
                                        <div style={styles.card}>
                                            <div style={styles.cardImg}>
                                                <img style={styles.imgMedia} src={imgProduto} alt={item.nomeSite} />
                                            </div>
                                            <div style={styles.cardInfo}>
                                                <span style={styles.descProd}>{item.nomeSite}</span>
                                                <span style={styles.vrProd}>{`R$ ${Helpers.formataValorPtBr(item.vrProduto)}`}</span>
                                            </div>
                                        </div>
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                ))}
            </div>
        </Container>
    );
}

export default Produtos;